import { gql } from '@apollo/client';

const advertiser = `
  _id
  country
  name
  slug
  image
`

export const CREATE_ADVERTISER = gql`
  mutation AdvertiserCreateOne($record: CreateAdvertiserInput!) {
    AdvertiserCreateOne(record: $record) {
      ${advertiser}
    }
  }
`

export const GET_ADVERTISERS = gql`
  query AdvertiserMany($page: Int, $perPage: Int, $filters: CompanyFilterArgs) {
    advertisers: AdvertiserMany(page: $page, perPage: $perPage, filters: $filters) {
      items {
        ${advertiser}
      }
      meta {
        totalPages
        totalItems
      }
    }
  }
`

export const UPDATE_ADVERTISER = gql`
  mutation CompanyUpdateById($record: UpdateCompanyInput!, $id: ObjectId!) {
    CompanyUpdateById(record: $record, _id: $id) {
      ${advertiser}
    }
}
`
